export const customAccountDataKey = 'custom_account_data';
export const customUserDataKey = 'custom_user_data';
export const customSalesOrderDataKey = 'custom_sales_order_data';
export const customProductDataKey = 'custom_product_data';
export const customContactDataKey = 'contact_data';
export const customCompanyDataKey = 'company_data';
export const customActivityDataKey = 'activity_data';
export const customOpportunityDataKey = 'opportunity_data';
export const customCustomObjectDataKey = 'custom_object_data';
